// import { NAVTABS } from '@/utils/templates/Browser/browser.constants';
import i18n from '@/plugins/i18n';

export const getBMNavTabs = () => [
  {
    name: i18n.global.t('application'),
    path: 'application',
    fullPath: '/browser/application',
  },
  {
    name: i18n.global.t('pages'),
    path: 'pages',
    fullPath: '/browser/pages',
  },
  {
    name: i18n.global.t('bm.errors'),
    path: 'errors',
    fullPath: '/browser/errors',
  },
];

const browser = {
  key: 'browser',
  name: i18n.global.t('browserMonitoring'),
  icon: 'browser',
  navTabs: getBMNavTabs(),
};
export default browser;
